import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// load company list
function* signatureImageLoadCompanyList(action) {
  const {
    data: { accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/get-company-list`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.signatureImageLoadCompanyList.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.signatureImageLoadCompanyList.failure())
  }
}

// load table log
function* signatureImageLoadTableLog(action) {
  const {
    data: { page, pageSize, orderBy, orderType, filterObj, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/log`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        filterObj,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.signatureImageLoadTableLog.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.signatureImageLoadTableLog.failure())
  }
}

// get detail
function* signatureImageGetDetail(action) {
  const {
    data: { id, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/detail`,
      {
        id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.signatureImageGetDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.signatureImageGetDetail.failure())
  }
}

// create signature image
function* signatureImageCreate(action) {
  const {
    data: {
      files,
      img_name,
      companies_id,
      m_user_id,
      created_by,
      updated_by,
      accessToken,
    },
  } = action.payload

  const formData = new FormData()

  formData.append('files', files)
  formData.append('img_name', img_name)
  formData.append('m_user_id', m_user_id)
  formData.append('companies_id', companies_id)
  formData.append('created_by', created_by)
  formData.append('updated_by', updated_by)

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/create`,
      formData,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.signatureImageCreate.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.signatureImageCreate.failure())
  }
}

// update signature image
function* signatureImageUpdate(action) {
  const {
    data: {
      id,
      files,
      img_name,
      companies_id,
      m_user_id,
      updated_by,
      accessToken,
    },
  } = action.payload

  const formData = new FormData()

  formData.append('id', id)
  formData.append('files', files)
  formData.append('m_user_id', m_user_id)
  formData.append('img_name', img_name)
  formData.append('companies_id', companies_id)
  formData.append('updated_by', updated_by)

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/update`,
      formData,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.signatureImageUpdate.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.signatureImageUpdate.failure())
  }
}

// delete signature image
function* signatureImageDelete(action) {
  const {
    data: { id, updated_by, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/delete`,
      {
        id,
        updated_by,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.signatureImageDelete.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.signatureImageDelete.failure())
  }
}

// load user
function* signatureImageLoadUser(action) {
  const {
    data: { company_id, accessToken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/signature-image/get-user-list`,
      {
        company_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.signatureImageLoadUser.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.signatureImageLoadUser.failure())
  }
}

export default function* watchSignatureImage() {
  yield all([
    takeEvery(
      actions.SIGNATURE_IMAGE_LOAD_COMPANY_LIST.REQUEST,
      signatureImageLoadCompanyList
    ),

    takeEvery(
      actions.SIGNATURE_IMAGE_LOAD_TABLE_LOG.REQUEST,
      signatureImageLoadTableLog
    ),
    takeEvery(
      actions.SIGNATURE_IMAGE_GET_DETAIL.REQUEST,
      signatureImageGetDetail
    ),
    takeEvery(actions.SIGNATURE_IMAGE_CREATE.REQUEST, signatureImageCreate),
    takeEvery(actions.SIGNATURE_IMAGE_UPDATE.REQUEST, signatureImageUpdate),
    takeEvery(actions.SIGNATURE_IMAGE_DELETE.REQUEST, signatureImageDelete),
    takeEvery(
      actions.SIGNATURE_IMAGE_LOAD_USER.REQUEST,
      signatureImageLoadUser
    ),
  ])
}
export {
  signatureImageLoadCompanyList,
  signatureImageLoadTableLog,
  signatureImageGetDetail,
  signatureImageCreate,
  signatureImageUpdate,
  signatureImageDelete,
  signatureImageLoadUser,
}
